import { render, staticRenderFns } from "./EmploymentForm.vue?vue&type=template&id=120c0a73&scoped=true"
import script from "./EmploymentForm.vue?vue&type=script&lang=js"
export * from "./EmploymentForm.vue?vue&type=script&lang=js"
import style0 from "./EmploymentForm.vue?vue&type=style&index=0&id=120c0a73&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120c0a73",
  null
  
)

export default component.exports